module.exports = __webpack_public_path__ + "static/media/img_pqrs@2x.36083180.png";